export const FILE_TYPE = {
  NEW_SCHOOL: 'NEW_SCHOOL',
  SYNC_PROJECTOR_BASED: 'SYNC_PROJECTOR_BASED',
};

export const FILE_IMPORT_STATUS = {
  NEW: 'NEW',
  PROCESSING: 'PROCESSING',
  SUCCESSFUL: 'SUCCESSFUL',
  FAILED: 'FAILED',
};
